import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock';
import { TypedMemo } from '../../../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the AI reels plan; each part uses its own slice of it */
import styles from './ReelsPlan.module.scss';
/* eslint-enable css-modules/no-unused-class */

export interface ReelsPlanSegmentOption {
  value: string;
  label: string;
  /** The plan does not allow the option: it shows a lock, and a click calls `onLocked`. */
  locked?: boolean;
}

interface ReelsPlanSegmentProps {
  /** The name of the group for a screen reader ("Length"). */
  label: string;
  options: ReelsPlanSegmentOption[];
  value: string;
  disabled: boolean;
  onChange: (value: string) => void;
  /** A field after the options (the number of "Other"). */
  children?: React.ReactNode;
  /** A click on a locked option (the plan offer). */
  onLocked?: () => void;
}

/**
 * One row of options of the setup (design rollout-plan f1 `.fp-seg`): one option is on. A locked
 * option shows a lock; its click calls `onLocked`, never `onChange`.
 */
const ReelsPlanSegmentComponent: React.FC<ReelsPlanSegmentProps> = ({
  label,
  options,
  value,
  disabled,
  onChange,
  children,
  onLocked,
}) => (
  <div className={styles.seg} role="radiogroup" aria-label={label}>
    {options.map((option) => {
      const isLocked = option.locked === true;
      return (
        <button
          key={option.value}
          type="button"
          role="radio"
          aria-checked={option.value === value}
          aria-disabled={isLocked || undefined}
          className={clsx(styles.opt, option.value === value && styles.optOn, isLocked && styles.optLocked)}
          disabled={disabled}
          onClick={() => (isLocked ? onLocked?.() : onChange(option.value))}
        >
          {option.label}
          {isLocked && <FontAwesomeIcon icon={faLock} aria-hidden />}
        </button>
      );
    })}
    {children}
  </div>
);

export const ReelsPlanSegment = TypedMemo(ReelsPlanSegmentComponent);
